import { useState, useEffect } from "react";

// Language Selector Component - Custom with Google Translate cookies
const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('es');
  
  const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'zh-CN', name: '中文', flag: '🇨🇳' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' }
  ];

  // Function to set Google Translate cookie and trigger translation
  const translatePage = (langCode) => {
    setCurrentLang(langCode);
    setIsOpen(false);
    
    // Set the Google Translate cookie
    const domain = window.location.hostname;
    document.cookie = `googtrans=/es/${langCode}; path=/; domain=${domain}`;
    document.cookie = `googtrans=/es/${langCode}; path=/`;
    
    // Also set for .emergentagent.com domain if applicable
    if (domain.includes('emergentagent.com')) {
      document.cookie = `googtrans=/es/${langCode}; path=/; domain=.emergentagent.com`;
    }
    
    // Try to trigger Google Translate if available
    const selectElement = document.querySelector('.goog-te-combo');
    if (selectElement) {
      selectElement.value = langCode;
      selectElement.dispatchEvent(new Event('change'));
    } else {
      // Fallback: reload page to apply cookie
      window.location.reload();
    }
  };

  // Read current language from cookie on mount
  useEffect(() => {
    const match = document.cookie.match(/googtrans=\/es\/([^;]+)/);
    if (match && match[1]) {
      setCurrentLang(match[1]);
    }
  }, []);

  const currentLanguage = languages.find(l => l.code === currentLang) || languages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-gray-300 hover:text-[#c9a962] transition-colors px-3 py-2 rounded-lg glass"
        data-testid="language-selector"
        aria-label="Seleccionar idioma"
      >
        <span className="text-lg">{currentLanguage.flag}</span>
        <span className="hidden sm:inline text-sm">{currentLanguage.name}</span>
        <i className={`fas fa-chevron-down text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      
      {isOpen && (
        <>
          {/* Overlay to close menu */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full right-0 mt-2 glass rounded-lg overflow-hidden min-w-[160px] z-50 shadow-xl border border-[#c9a962]/20">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => translatePage(lang.code)}
                className={`w-full px-4 py-3 text-left text-sm transition-colors flex items-center gap-3 ${
                  currentLang === lang.code 
                    ? 'bg-[#c9a962]/20 text-[#c9a962]' 
                    : 'text-gray-300 hover:bg-[#c9a962]/10 hover:text-[#c9a962]'
                }`}
                data-testid={`lang-${lang.code}`}
              >
                <span className="text-lg">{lang.flag}</span>
                <span>{lang.name}</span>
                {currentLang === lang.code && (
                  <i className="fas fa-check ml-auto text-[#c9a962]"></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
      
      {/* Hidden Google Translate element */}
      <div id="google_translate_element" style={{ display: 'none' }}></div>
    </div>
  );
};

export default LanguageSelector;
